/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddMethod from './AddMethod/index'
import React from 'react'
import ReusableMethods from './ReusableMethods/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content",
  method,
  locationId,
  person,
  amount,
  onPaymentPageCallback,
  reusableForBluefin
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="semibold"
 marginBottom={dtSpaceXxs}
 text="Select a payment method"
/>
<ReusableMethods
  viewPath={`${viewPath}/ReusableMethods`}
/>
<AddMethod
  viewPath={`${viewPath}/AddMethod`}
 method={method}
 locationId={locationId}
 person={person}
 amount={amount}
 onPaymentPageCallback={onPaymentPageCallback}
 reusableForBluefin={reusableForBluefin}
/>
{children}
</React.Fragment>)
}